import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=5259eb95&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5259eb95')) {
      api.createRecord('5259eb95', component.options)
    } else {
      api.reload('5259eb95', component.options)
    }
    module.hot.accept("./Step3.vue?vue&type=template&id=5259eb95&", function () {
      api.rerender('5259eb95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/Step3.vue"
export default component.exports